class Breadcrumbs extends HTMLElement {
  constructor() {
    super()

    this.type = this.dataset.type
    this.collection = this.dataset.collection
    this.collectionUrl = this.dataset.collectionUrl
    this.storageKey = 'lastVisitedCollection'
  }

  async connectedCallback() {
    if (this.type === 'collection') {
      const collection = JSON.stringify({ collection: this.collection, collectionUrl: this.collectionUrl })
      sessionStorage.setItem(this.storageKey, collection)

    } else if (this.type === 'product') {
      const item = document.querySelector('[data-breadcrumbs-el="item"]')
      const collection = JSON.parse(sessionStorage.getItem(this.storageKey))

      if (sessionStorage.getItem(this.storageKey)) {
        item.innerHTML = `
          <a
            class="pdp-breadcrumbs__link"
            href="${collection.collectionUrl}"
          >
            ${collection.collection},
          </a>
        `
      }

      sessionStorage.removeItem(this.storageKey)

    } else {
      sessionStorage.removeItem(this.storageKey)
    }
  }
}

customElements.define('page-breadcrumbs', Breadcrumbs);
